import axios from "axios";
import { Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const EngagementDetailsActions = {
  GET_ENGAGEMENT_DETAIL: "GET_ENGAGEMENT_DETAIL",
  GET_ENGAGEMENT_DETAIL_SUCCESS: "GET_ENGAGEMENT_DETAIL_SUCCESS",
  GET_ENGAGEMENT_DETAIL_ERROR: "GET_ENGAGEMENT_DETAIL_ERROR",
};

export function getAllEngagementDetails(props) {
  const { access_token, partnerFirmId } = props;
  return (dispatch, getState) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getAllEngagementDetailsByPartnerFirmId`,
      params: {
        partnerFirmId: partnerFirmId,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllEngagementDetailsSuccess(response.data));
          return response.data;
        } else {
          const error = new Error(response.error);
          dispatch(getAllEngagementDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getAllEngagementDetailsError(err));
          return err;
        }
        if (!err.response) {
          dispatch(getAllEngagementDetailsError("Internal Server Error!"));
        }
      });
}

export function getAllEngagementDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: EngagementDetailsActions.GET_ENGAGEMENT_DETAIL_SUCCESS,
      payload: props,
    });
  };
}
export function getAllEngagementDetailsError(error) {
  return (dispatch) => {
    dispatch({
      type: EngagementDetailsActions.GET_ENGAGEMENT_DETAIL_ERROR,
      payload: error,
    });
  };
}
